<div app-layout>
  @if ((loading$ | async) === false) {
    @if (collections$ | async; as collections) {
      @if ((collections | noEmpty) && (collectionsSelected() | noEmpty)) {
        @for (collection of collections; track $index; let collectionIndex = $index) {
          @if (filtered(collection.id, collectionsSelected())) {
            <div class="relative">
              <div class="mb-4 flex items-center justify-between">
                <div class="flex items-center justify-start pl-2">
                  <svg-icon class="flex h-8 w-8 text-theme-500" src="assets/icons/icon-files.svg"></svg-icon>
                  <h2 class="mr-3 pl-5 text-2xl">{{ collection.nome }}</h2>
                  <p class="whitespace-nowrap text-md text-theme-500">
                    ({{ collection.cursos.length }} {{ 'trilhas.curso.cursos' | translate }})
                  </p>
                </div>
              </div>
              <div class="flex flex-wrap gap-4">
                @for (course of collection.cursos; track $index; let i = $index) {
                  @if (filtered(course.id, coursesSelected())) {
                    <div class="w-80">
                      <app-card-course
                        [course]="course"
                        [openCourseId]="course?.id"
                        (openCourse)="setCourseSelected($event, collection.id)"
                      ></app-card-course>
                    </div>
                  }
                }
              </div>
            </div>
          }
        }
        <!-- <div class="absolute right-0 -top-16 md:-top-6 md:right-20">
        <ng-container>
          <button
            app-button
            type="button"
            (click)="onOpenDashboard()"
            class="mt-3 !rounded-full bg-gray-100 p-5 hover:brightness-95 active:brightness-90"
          >
            <svg-icon class="w-6 mr-2 text-theme-700" src="assets/icons/icon-dashboard.svg"></svg-icon>
            <span translate class="hidden !text-md !text-theme-800 md:block">Dashboard</span>
          </button>
        </ng-container>
      </div> -->
      } @else {
        <ng-container *ngTemplateOutlet="empty"></ng-container>
      }
    } @else {
      <ng-container *ngTemplateOutlet="loading"></ng-container>
    }
  } @else {
    <ng-container *ngTemplateOutlet="loading"></ng-container>
  }
</div>

<ng-template #empty>
  <div class="h-[calc(100vh-10rem)] w-full">
    <app-jumbotron translate>trilhas.lista-vazia</app-jumbotron>
  </div>
</ng-template>

<ng-template #loading>
  <div>
    <div class="container">
      <div class="mb-4 flex items-center justify-between">
        <div class="flex items-center justify-start pl-2">
          <svg-icon class="flex h-8 w-8 text-theme-500" src="assets/icons/icon-files.svg"></svg-icon>
          <app-skeleton class="ml-2 flex h-8! w-96!"></app-skeleton>
        </div>
      </div>

      <app-horizontal-scroll class="h-full">
        <div class="flex h-full w-fit gap-2 px-5">
          @for (item of [1, 2, 3]; track $index) {
            <app-card>
              <div app-card-content>
                <app-skeleton class="flex h-[23rem]! w-80!"></app-skeleton>
              </div>
            </app-card>
          }
        </div>
      </app-horizontal-scroll>
    </div>
  </div>
</ng-template>
